import { useState } from 'react';
import {
  LINK_QUALITY_LABELS,
  initialLinkQualityDisplay,
  nextLinkQualityDisplay,
} from '../../../lib/linkQuality';

/**
 * 列表 / 卡片里的信号质量读数。
 *
 * 信号链路不是本平台的监管重点，而且它是缓变量、原始值每帧都有零点几个百分点
 * 的抖动，所以这里只给「良好 / 一般 / 稍弱 / 很差」四档文字（配色沿用同一套档位），
 * 精确百分比收进 `title`，并在「单机管理」的完整数据列表里可见 ——
 * 进度条这一视觉重点留给真正关键的电量。
 *
 * 换档带死区与驻留（见 `lib/linkQuality`），读数不会压在档位边界上来回闪。
 *
 * @param frame 遥测帧号（`DroneTelemetry.seq`），用于按帧而不是按渲染计数
 */
export function LinkQualityText({
  value,
  frame,
  className,
}: {
  value: number;
  frame: number;
  className?: string;
}) {
  const [display, setDisplay] = useState(() => initialLinkQualityDisplay(value, frame));
  // 渲染期用 props 派生 state（React 官方支持的写法）：状态未变化时
  // next 与 display 是同一个对象，因此不会形成渲染循环。
  const next = nextLinkQualityDisplay(display, value, frame);
  if (next !== display) setDisplay(next);

  // 文字与颜色都取自「已生效的档位」，两者永远描述同一档，
  // 不会出现显示良好却是告警色的割裂，也不会因原始值抖动而单独闪色。
  const tone = display.level;
  const label = LINK_QUALITY_LABELS[tone];
  return (
    <span
      className={[tone === 'ok' ? 'text-fg-muted' : 'text-fg', className].filter(Boolean).join(' ')}
      style={tone === 'ok' ? undefined : { color: `var(--${tone})` }}
      title={`链路质量 ${value.toFixed(0)}%（${label}）`}
    >
      {label}
    </span>
  );
}
